import { handleActions } from 'redux-actions'

import * as allFormsActions from '../actions'

const defaultState = []

export default handleActions(
  {
    [allFormsActions.getPagedAllFormsSuccess](state, action) {
      return action.response.data
    },
    [allFormsActions.resetAllFormsPage](state, action) {
      return defaultState
    },
  },
  defaultState
)
